export const seoEn =
  {
    homeTitle: "OTM Trading System | Boost your trading with volume and delta analysis.",
    homeMeta: "Improve your profits in the futures market with OTM Trading: the powerful software of technical indicators that will revolutionize your strategy. Discover how to increase your performance with accurate and reliable information on volume and delta. Optimize your trades now!",
  };


export const seoEs =
  {
    homeTitle: "OTM Trading System | Potencia tu trading con análisis de volumen y delta",
    homeMeta: "Mejora tus ganancias en el mercado de futuros con OTM Trading: el poderoso software de indicadores técnicos que revolucionará tu estrategia. Descubre cómo aumentar tu rendimiento con información precisa y confiable sobre volumen y delta. ¡Optimiza tus operaciones ahora!",
  };
